module.exports = __webpack_public_path__ + "static/media/illustrator.353d70c7.png";